import React, { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import Credential from "../Credential";
import { getFirstAndLastNames } from "../../utils/Functions";
import { Button } from "@material-ui/core";
import styled from "styled-components";

const StyledButton = styled(Button)`
    && {
        min-width: 200px;
        height: 40px;
        font-weight: 600;

        @media (max-width: 768px) {
            width: 100%;
        }
    }
`;

const BatchPrint = ({ people, fields }) => {
    const printRef = useRef();

    const handlePrint = useReactToPrint({
        content: () => printRef.current,
        documentTitle: "Credenciais",
        pageStyle: `
            @page { size: 100mm 50mm; margin: 0; }
            body { margin: 0; }
            .tag {
                width: 100mm;
                height: 50mm;
                display: flex;
                align-items: center;
                justify-content: center;
                box-sizing: border-box;
                page-break-inside: avoid;
            }
        `,
    });

    return (
        <div>
            {/* Área escondida para impressão */}
            <div style={{ display: "none" }}>
                <div ref={printRef}>
                    {people.map((person) => (
                        <div key={person.id} className="tag">
                            <Credential
                                id={person?.id}
                                name={fields?.name ? getFirstAndLastNames(person.name) : ""}
                                company={fields?.company ? person.company : ""}
                                role={fields?.role ? person.role : ""}
                                qrcode={fields?.qrcode}
                                qrcodeSize={fields?.qrcodeSize ? fields.qrcodeSize : "1"}
                                qrcodePosition={fields?.qrcodePosition ? fields.qrcodePosition : "left"}
                            />
                        </div>
                    ))}
                </div>
            </div>

            <StyledButton variant="contained" color="primary" onClick={handlePrint} disabled={people.length === 0}>
                Imprimir {people.length > 0 ? `(${people.length})` : ""}
            </StyledButton>
        </div>
    );
};

export default BatchPrint;
